<template>
<nav class='menu'>
  <img
    id='logo1'
    class='logo'
    :src="imgLeft"
  >
  <img
    id='logo2'
    class='logo'
    style="float: right"
    :src="imgRight"
  >
</nav>
</template>

<script>
export default {
  name: 'nav-top-presenter',

  props: {
    imgLeft: {
      default: require('../assets/img/trg-logo.svg')
    },
    imgRight: {
      default: require('../assets/img/trg-logo.svg')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NavTopPresenter.vue